export class VeronicaAPIErrorData {

    success:boolean;
    result:VeronicaAPIErrorResultData;
}

export class VeronicaAPIErrorResultData {
    status:string;
    timestamp:string;
    message:string;
    debugMessage:string;
    subErrors:VeronicaApiSubErrorData[];
}

export class VeronicaApiSubErrorData {
    object:string;
    field:string;
    rejectedValue:string;
    message:string;
}